<!--  -->
<template>
  <div class="zdbookrecharge">
    <div>
      <div class="xian">活动信息</div>
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
        <el-form-item label="活动标题" prop="title">
          <el-input v-model="ruleForm.title" style="width: 250px" />
          <span class="xin">标题将不展示给用户，只供内部显示</span>
        </el-form-item>
        <el-form-item label="活动展示标题" prop="ftitle">
          <el-input v-model="ruleForm.ftitle" v-model.trim="ruleForm.ftitle" style="width: 250px" @input="ruleForm.ftitle = ruleForm.ftitle.replace(reg, '')" />
          <span class="xin">标题会显示于活动页面上及签到尾部和阅读页底部</span>
        </el-form-item>
        <el-form-item label="期限选择">
          <el-select v-model="time_type" placeholder="请选择" style="width:300px">
            <el-option
              v-for="item in timeoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="time_type === 2" label="固定天数" prop="appoint_day">
          <el-input v-model="ruleForm.appoint_day" style="width:300px" placeholder="请输入固定天数" type="number" :onkeyup="ruleForm.appoint_day = ruleForm.appoint_day.replace(/[^A-z0-9]/, '')" />
        </el-form-item>
        <el-form-item v-if="time_type === 1" label="活动时间" prop="date">
          <el-date-picker
            v-model="ruleForm.date"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm"
            :default-time="['00:00:00', '23:59:59']"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:410px"
            :picker-options="pickerOptions"
            :clearable="false"
            @change="datavalue"
          />
        </el-form-item>
        <el-form-item label="活动金额" prop="name">
          <el-radio-group
            v-model="ruleForm.activityAmount"
            style="background-color: rgb(243 242 242); padding: 12px;"
          >
            <div>
              <el-radio label="系统金额" />
              <el-select v-model="ruleForm.custom_select_index" :disabled="ruleForm.activityAmount==='自定义金额' ? true : false" placeholder="请选择" style="margin-left: 19px;">
                <el-option
                  v-for="item in programme"
                  :key="item.value"
                  :label="item.description"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div style="display: flex;align-items: center;font-size: 15px; margin-top: 13px;">
              <el-radio label="自定义金额" />
              <div>充<el-input v-model="ruleForm.money" :disabled="ruleForm.activityAmount==='系统金额' ? true : false" style="width:100px" />元得0书币赠送<el-input v-model="ruleForm.book_money" :disabled="ruleForm.activityAmount==='系统金额' ? true : false" style="width:100px" />书卷</div>
            </div>
            <div
              style="font-size: 14px;  color: #d72323; margin-top: 30px;"
            >
              <span>注：</span>
              <p>1、0.1≤充值金额≤500；赠送书卷≤150*充值金额</p>
              <p>2、创建后金额将不可修改</p>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="限充类型" prop="name">
          <el-select v-model="ruleForm.limit_type" placeholder="请选择" style="width:300px">
            <el-option
              v-for="item in chargeLimitingType"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="限充次数" prop="name">
          <el-select v-model="ruleForm.limit_num" placeholder="请选择" style="width:300px">
            <el-option
              v-for="index in 100"
              :key="index"
              :label="index"
              :value="index"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <div class="xian">活动入口</div>
      <el-form>
        <el-form-item label="活动入口" prop="name">
          <el-checkbox-group v-model="ruleForm.activityEntrance">
            <el-checkbox label="阅读页底部" name="type" />
            <el-checkbox label="签到提示消息末尾" name="type" />
            <el-checkbox label="阅读页弹窗" name="type" />
            <el-checkbox label="互动召回消息末尾" name="type" />
            <el-checkbox label="订阅通知" name="type" />
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="可见用户" prop="name">
          <el-form-item
            label="付费状态"
            prop="name"
            style="display: flex;align-items: center;"
          >
            <el-radio-group v-model="ruleForm.paramcontent.condition_user">
              <el-radio label="全部用户" name="type" />
            </el-radio-group>
          </el-form-item>
          <el-form-item label="注册天数" prop="name" class="el-mid">
            <div style="display: flex;">第<el-input v-model="ruleForm.reg_start" style="width:50px;margin:0px 5px;" /><div class="span-mid">
              天 - 第
            </div><el-input v-model="ruleForm.reg_end" style="width:50px;margin:0px 5px;" />天</div>
          </el-form-item>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <div class="xian">模版选择</div>
      <el-form>
        <el-form-item label="模版" prop="name">
          <span>{{ ruleForm.templateid && ruleForm.templateid.description }}</span>
          <div style="display: flex;align-items: end;">
            <div v-if="false" class="moban">空</div>
            <img :src="ruleForm.templateid && ruleForm.templateid.img" style="width:150px; height: 220px">
            <el-button type="primary" style="height: 34px;margin-left:10px" @click="dialogVisible = true">更换模版</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div>
      <el-button type="primary" style="height: 34px;margin-left:10px" @click="submitForm('ruleForm')">保存</el-button>
    </div>

    <el-dialog
      title="选择模版"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <div class="Template">
        <ul class="content">
          <li v-for="item in theme" :key="item.id" class="content_li" :class="{active: ruleForm.templateid && ruleForm.templateid.value === item.value}" @click="(ruleForm.templateid = item),(dialogVisible = false)">
            <span class="li_span">{{ item.description }}</span>
            <img class="li_img" :src="item.img">
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { readingservice, acawraccountlist } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    var checkAger = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.appoint_day.length > 3) {
        callback(new Error('不能超过3位'))
      } else {
        callback()
      }
    }
    var checkAge = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.date[0] == this.ruleForm.date[1]) {
        callback(new Error('不能选择相同的时间'))
      } else {
        callback()
      }
    }
    return {
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      dialogVisible: false,
      ruleForm: {
        title: null, // 活动标题
        date: [], // 活动时间
        ftitle: null, // 活动展示标题
        activityEntrance: [], // 活动入口
        custom_select: null, // 活动金额
        custom_select_index: null, // 选择系统金额时必传
        limit_type: null, // 限充类型
        limit_num: null, // 限充次数
        templateid: null, // 活动模版值
        money: null, // 充值金额
        activityAmount: null, // 活动金额
        book_money: null, // 赠送书卷
        isfoot: null, // 阅读底部
        istan: null, // 阅读页弹窗
        issubscribe: null, // 订阅通知
        issign: null, // 签到提示消息末尾
        isinteraction: null, // 互动召回消息末尾
        appoint_day: '',
        paramcontent: {
          istan_type: null, // 不展示默认传1
          condition_user: '全部用户', // 可见用户全部用户 1 未付费用户 2 已付费用户 3
          reg_start: '', // 前注册天数默认传空字符串
          reg_end: '' // 后注册天数默认传空字符串
        }
      },
      rules: {
        date: [
          { type: 'array', required: true, message: '请选择时间', trigger: 'change' },
          { validator: checkAge, trigger: 'change' }
        ],
        appoint_day: [
          { required: true, message: '请输入固定天数', trigger: 'change' },
          { validator: checkAger, trigger: 'change' }
        ]
      },
      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      programme: [],
      theme: [],
      chargeLimitingType: [{ value: '整体限充', id: 0 }, { value: '每天限充', id: 1 }],
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        }, {
          value: 2,
          label: '固定天数'
        }
      ],
      time_type: 2
    }
  },
  created() {
    window.aa = this
    this.getTypeData()
  },
  mounted() {

  },
  methods: {
    datavalue(val) {
      this.start_time = val[0]
      this.end_time = val[1]
    },
    async getTypeData() {
      const data = await acawraccountlist({
        platformId: this.platformid,
        activityType: 1 })
      this.programme = data.data.programme
      this.theme = data.data.theme
      this.ruleForm.templateid = this.theme[0]
    },

    submitForm(formName) {
      this.$refs[formName].validate(async(valid) => {
        const obj = this.assemblyParameters()
        if (valid && this.judgmentParameters(obj)) {
          const par = {}
          if (this.time_type === 1) {
            par.time_type = this.time_type
            par.start_time = this.start_time
            par.end_time = this.end_time
          } else {
            par.time_type = this.time_type
            par.appoint_day = Number(this.ruleForm.appoint_day)
          }
          await readingservice({
            platform_id: this.platformid,
            activity_type: 1,
            ...par,
            activity_info: {
              data: obj,
              action: 'save-sales'
            }
          })
          this.$emit('close')
          this.$message({
            type: 'success',
            message: '添加成功!'
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 组装参数
    assemblyParameters() {
      const op = {
        '全部用户': 1,
        '未付费用户': 2,
        '已付费用户': 3
      }
      const obj = {
        id: 0,
        title: this.ruleForm.title,
        ftitle: this.ruleForm.ftitle,
        // start_date: this.ruleForm.date.length ? this.ruleForm.date[0] : null,
        // end_date: this.ruleForm.date.length ? this.ruleForm.date[1] : null,
        custom_select: this.ruleForm.activityAmount === '系统金额' ? 1 : this.ruleForm.activityAmount === '自定义金额' ? 2 : null,
        custom_select_index: this.ruleForm.custom_select_index,
        money: this.ruleForm.money,
        limit_type: this.ruleForm.limit_type,
        limit_num: this.ruleForm.limit_num,
        templateid: this.ruleForm.templateid.value,
        book_money: this.ruleForm.book_money,
        isfoot: this.ruleForm.isfoot ? 1 : this.ruleForm.isfoot,
        istan: this.ruleForm.istan ? 1 : this.ruleForm.istan,
        issubscribe: this.ruleForm.issubscribe ? 1 : this.ruleForm.issubscribe,
        issign: this.ruleForm.issign ? 1 : this.ruleForm.issign,
        isinteraction: this.ruleForm.isinteraction ? 1 : this.ruleForm.isinteraction,
        paramcontent: {
          condition_user: op[this.ruleForm.paramcontent.condition_user],
          reg_start: this.ruleForm.paramcontent.reg_start ? this.ruleForm.paramcontent.reg_start : '',
          reg_end: this.ruleForm.paramcontent.reg_end ? this.ruleForm.paramcontent.reg_end : ''
        }
      }

      obj.custom_select === 2 && delete obj.custom_select_index
      obj.custom_select === 1 && delete obj.money
      obj.custom_select === 1 && delete obj.book_money
      obj.isfoot || delete obj.isfoot
      obj.istan || delete obj.istan
      obj.issubscribe || delete obj.issubscribe
      obj.issign || delete obj.issign
      obj.isinteraction || delete obj.isinteraction
      return obj
    },

    // 判断参数
    judgmentParameters(obj) {
      // else if (!obj.start_date) {
      //   tips = '请选择活动时间'
      // }
      let tips = null
      if (!obj.title) {
        tips = '请输入活动标题'
      } else if (!obj.ftitle) {
        tips = '请输入活动展示标题'
      } else if (!obj.custom_select) {
        tips = '请选择金额类型'
      } else if (obj.custom_select === 1 && !obj.custom_select_index) {
        tips = '请选择系统金额的类型'
      } else if (typeof (obj.limit_type) !== 'number') {
        tips = '请选择限充类型'
      } else if (!obj.limit_num) {
        tips = '请选择限充次数'
      } else if (typeof (obj.templateid) !== 'number') {
        tips = '请选择活动模版'
      } else if (!obj.paramcontent.condition_user) {
        tips = '请选择可见用户'
      }

      tips && this.$message({
        message: tips,
        type: 'warning'
      })

      return !tips
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.xian{
    font-size: 19px;
    padding-bottom: 15px;
    border-bottom: 3px solid #ccc;
    margin-bottom: 23px;
}
.xin{
  margin-top: -8px;
}

.moban{
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid black;
}

.Template{

}
.Template .content{
    display: flex;
    flex-wrap: wrap;
}
.Template .content .content_li{
  list-style-type:none;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  cursor: pointer;
}

.Template .content .content_li.active{
  background-color: #abcdef;
}

.Template .content .content_li:hover{
   background-color: #abcdef;
}

.Template .content .content_li .li_span{

}
.Template .content .content_li .li_img{
    width: 150px;
    height: 250px;
}
</style>

<style>
.zdbookrecharge .el-form-item--medium .el-form-item__content{
  display: flex;
  flex-direction: column;
}
@media (max-width: 768px){
  .el-mid .el-form-item__content .el-input--medium .el-input__inner{
    width:50px;
  }
  .span-mid{
    width:28vw;
  }
}

</style>
